<template>
  <div class="basic" v-if="options && syouninGroupDetail">
    <div class="form">
      <div class="flex flex-align-center">
        <p class="head">承認種別：</p>
        <!-- <select-box :options="options.syounin_types" v-model="syouninGroupDetail.syounin_type" disabled="true"></select-box> -->
        <label>{{getSyouninTypeLabel()}}</label>
      </div>
      <div class="flex flex-align-center">
        <p class="head">承認グループ名：</p>
        <input-text type="text" max-length="128" v-model="syouninGroupDetail.group_name"></input-text>
      </div>
    </div>

    <div class="btn-container">
      <p class="btn-temporary-save">
        <button type="button" @click="updateGroupInfo" :disabled="isUpdating">
          <template v-if="isUpdating">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>承認グループ更新中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>更新する</template>
        </button>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { SyouninGroupDetail, SyouninGroupOptions } from '@/types/SyouninGroup';
import { useSyouninGroup } from '@/composable/master/syounin_group/syounin_group';
import OptionConst from '@/const/Option';

export default defineComponent({
  props: {
    syouninGroupDetail: {
      type: Object as () => SyouninGroupDetail | null,
      default: null
    },
    options: {
      type: Object as () => SyouninGroupOptions | null,
      default: null
    }
  },
  emits: {
    reload() {
      return true
    }
  },
  setup(props, context) {
    const { isUpdating, updateSyouninGroup } = useSyouninGroup();

    // グループ名を更新
    const updateGroupInfo = async () => {
      if (!props.syouninGroupDetail) {
        return
      }
      await updateSyouninGroup(props.syouninGroupDetail)
      context.emit('reload')
    }

    const getSyouninTypeLabel = () => {
      let syouninTypeLabel = '';

      let tmp = OptionConst.SYOUNIN_FLOW_TYPES_OPTION.find(v => v.val == props.syouninGroupDetail?.syounin_type);
      if(tmp){
        syouninTypeLabel = tmp.label;
      }
      return syouninTypeLabel;

    }

    return {
      isUpdating,
      updateSyouninGroup,
      updateGroupInfo,
      OptionConst,
      getSyouninTypeLabel,
    }
  },
})
</script>

<style lang="scss" scoped>
@import "@scss/components/syounin_group_edit.scss";
</style>
